import { ChangeDetectionStrategy, ChangeDetectorRef, Component, InjectionToken, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { ROWITEM } from 'src/app/app.module';
import { SNItem } from 'src/app/models/snitem';
import { TypeManagerService } from 'src/app/services/type-manager.service';

@Component({
  selector: 'app-snitem-table-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './snitem-table-row.component.html',
  styleUrls: ['./snitem-table-row.component.scss']
})
export class SNItemTableRowComponent implements OnInit {

  @Input() item: SNItem; // item to be used in this row
  @Input() component: string; // component name to be used as the row component

  public rowcomponent;

  constructor(private typeManager: TypeManagerService, private injector: Injector, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.typeManager.typeMap(this.component)) {
      const componentFactory = this.typeManager.typeMap(this.component);
      this.rowcomponent = componentFactory;
      this.cdr.detectChanges();
    }
  }

  getInjector(itemToInject: SNItem) {
    return Injector.create({providers: [{provide: ROWITEM, useValue: itemToInject}], parent: this.injector});
  }

}
